import React from 'react';
import { CustomerEmail } from './CustomerEmail';
import { UpgradeSelection } from './UpgradeSelection';

export class ServiceUpgrade extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            upgradeCode: ''
        }
    }

    async componentDidMount() {
        if (this.props.match?.params.upgradeCode) {
            this.setState({
                step: 2,
                upgradeCode: this.props.match?.params.upgradeCode
            });
        }
    }

    render() {
        return (
            <div className="App m-5">
                <h1 className="title is-3 mt-3 mb-3">Service Upgrade</h1>
                {
                    this.state.step === 1 && <CustomerEmail />
                }
                {
                    this.state.step === 2 && <UpgradeSelection upgradeCode={this.state.upgradeCode} />
                }
            </div>
        )
    }
}